import Icon from "./Icons";

export default function DownloadAPKButton({
  className = "btn btn-primary",
  text = "Télécharger l'APK (bêta)",
  showIcon = false,
}) {
  return (
    <a
      href="https://backend.safe-app.io/apk/app-release.apk"
      download="app-release.apk"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {showIcon && <Icon name="android" className="btn-android-icon" />}
      {text}
    </a>
  );
}
